module.exports = __webpack_public_path__ + "static/year2006-5d2a0d19b849764b1b0d0a35bb9bd709.jpg";